'use es6';

import { createSelector } from 'reselect';
import { getSettings } from 'forms-utils-lib/settings/selectors';
const FORM_STYLE_KEY = 'Forms:Style';
export const getGlobalFormStyles = createSelector(getSettings, settings => {
  try {
    const styleValue = settings[FORM_STYLE_KEY].value;
    return JSON.parse(styleValue) || {};
  } catch (error) {
    return {};
  }
});